import { _ } from "i18n";

/**
 * Matches backend `Eyeball\Enum\AvailabilityType` string values for ops summary grids (filters + cells).
 */
export enum AvailabilityFilterValue {
	Online = "online",
	Offline = "offline",
}

/** Build at runtime so `_()` runs after i18n is ready (avoids first-load key strings in filters). */
export function getAvailabilityOnlineOfflineChoices(): Array<{ value: AvailabilityFilterValue; label: string }> {
	return [
		{ value: AvailabilityFilterValue.Online, label: _("admin.summary_tab.label.online") },
		{ value: AvailabilityFilterValue.Offline, label: _("admin.summary_tab.label.offline") },
	];
}
